module.exports = __webpack_public_path__ + "img/idc_datacenter_pic02.7702f84a.jpg";